/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs.js'

const $nsid = 'app.bsky.graph.getSuggestedFollowsByActor'

export { $nsid }

/** Enumerates follows similar to a given account (actor). Expected use is to recommend additional accounts immediately after following one account. */
const main = l.query(
  $nsid,
  l.params({ actor: l.string({ format: 'at-identifier' }) }),
  l.jsonPayload({
    suggestions: l.array(
      l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),
    ),
    recIdStr: l.optional(l.string()),
    isFallback: l.optional(l.withDefault(l.boolean(), false)),
    recId: l.optional(l.integer()),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
